import useSWR from 'swr'
import { Item_Settings } from '@graphql/queries'

const useItemSettings = () => {
    const { data, error } = useSWR(Item_Settings)
    const subjects = data?.subjects?.data ? data?.subjects?.data : []

    const subjectAreas = data?.subjectAreas?.data
        ? data?.subjectAreas?.data
        : []

    const schoolYears = data?.schoolYears?.data ? data?.schoolYears?.data : []

    const levels = data?.levels?.data ? data?.levels?.data : []

    const tags = data?.tags?.data ? data?.tags?.data : []

    // Options for selects
    const subjectOptions = subjects.map((subject) => {
        return { value: subject.id, name: subject.name }
    })
    const subjectAreaOptions = subjectAreas.map((subjectArea) => {
        return { value: subjectArea.id, name: subjectArea.name }
    })
    const schoolYearOptions = schoolYears.map((schoolYear) => {
        return { value: schoolYear.id, name: schoolYear.name }
    })
    const levelOptions = levels.map((level) => {
        return { value: level.id, name: level.name }
    })

    return {
        subjects,
        subjectAreas,
        schoolYears,
        levels,
        tags,
        subjectOptions,
        subjectAreaOptions,
        schoolYearOptions,
        levelOptions,

        isLoading: !error && !data,
        error,
    }
}

export { useItemSettings }
